import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HoopsToolbarIcon',
  props: {
  color: {
    default: 0,
    type: Number,
    validator (value: number) {
      return [0, 1, 2].includes(value)
    }
  },
  type: {
    type: String,
    required: true,
    validator (value: string) {
      const supportedIcons = [
        'back',                'bottom',
        'camera',              'click',
        'cuttingplane',        'cuttingplane-x',
        'cuttingplane-y',      'cuttingplane-z',
        'cuttingplane-face',   'cuttingplane-section',
        'cuttingplane-toggle', 'cuttingplane-reset',
        'explode',             'face',
        'front',               'hidden-line',
        'home',                'iso',
        'left',                'measure-angle',
        'measure-distance',    'measure-edge',
        'measure-point',       'note',
        'orbit',               'ortho',
        'persp',               'redline-circle',
        'redline-freehand',    'redline-note',
        'redline-rectangle',   'right',
        'select',              'area-select',
        'settings',            'shaded',
        'snapshot',            'top',
        'turntable',           'walk',
        'wireframe',           'wireframeshaded',
        'xray'
      ]

      return supportedIcons.includes(value)
    }
  }
},
  emits: ['click'],
  setup(__props) {



const props = __props

const hover = ref(false)
const iconType = `hoops-sprite-${props.type}`
const classArray = computed(() => {
    return [
      { [iconType]: true },
      { 'hover': hover.value }
    ]
  }
)
const toggleHover = () => {
  hover.value = !hover.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["drop-borders button hoops-sprite", classArray.value]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    onMouseover: toggleHover,
    onMouseout: toggleHover
  }, null, 34))
}
}

})